// import React, { useEffect, useState } from 'react';
// import { useSearchParams, useParams } from 'react-router-dom';
// import { collection, query, where, getDocs, doc, setDoc } from "firebase/firestore";
// import { httpsCallable } from "firebase/functions";
// import { firestoreB, functions } from "../firebaseConfig";
// import '../ThankYouPage.scss';

// const CallbackThankYou = () => {
//   const { action, userId } = useParams(); // Extract action and userId from the URL
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [message, setMessage] = useState(""); // Update the message displayed based on action

//   useEffect(() => {
//     console.log("CallbackThankYou component mounted.");

//     const checkUserAndProcessRequest = async () => {
//       if (!userId) {
//         setError("User ID is missing in the URL.");
//         setLoading(false);
//         return;
//       }

//       try {
//         console.log("Querying Firestore for userId:", userId);

//         // Query Firestore for a document with the matching userId in Project B
//         const userQuery = query(
//           collection(firestoreB, "testValEmails"), // Correct collection name
//           where("uniqueId", "==", userId) // Match the `uniqueId` field
//         );
//         const querySnapshot = await getDocs(userQuery);
        

//         if (querySnapshot.empty) {
//           setError("No user found with the provided ID.");
//           setLoading(false);
//           return;
//         }

//         // Extract the user data
//         const userData = querySnapshot.docs[0].data();
//         console.log("User data retrieved from Firestore:", userData);

//         // Determine the action to take based on the URL
//         let completedDripStatus = "";
//         let emailSubject = "";
//         let emailBody = "";

//         switch (action) {
//           case "callback":
//             completedDripStatus = "SaleRequest";
//             emailSubject = "Standard Callback Request to Sell";
//             emailBody = `Hi,\n\nUser ${userData.name} requested a standard callback to sell.\n...`; // Adjust details
//             setMessage("Thank you for your request! A representative will be in touch.");
//             break;

//           case "callback-more-info":
//             completedDripStatus = "MoreInfoRequest";
//             emailSubject = "Callback Request for More Information";
//             emailBody = `Hi,\n\nUser ${userData.name} requested more information about our services.\n...`; // Adjust details
//             setMessage("Thank you for your interest! A representative will be in touch.");
//             break;

//           case "callback-not-interested":
//             completedDripStatus = "Uninterested";
//             setMessage("Thank you for letting us know. We appreciate your feedback!");
//             break;

//           default:
//             setError("Invalid action specified in the URL.");
//             setLoading(false);
//             return;
//         }

//         // Log the completed drip status in Firestore
//         const logRef = doc(firestoreB, "completedDrips", userId);
//         await setDoc(logRef, { completedDripStatus, timestamp: new Date() });

//         // Send the follow-up email if required
//         if (action !== "callback-not-interested") {
//           const sendFollowUpEmail = httpsCallable(functions, "sendFollowUpEmail");
//           await sendFollowUpEmail({
//             uniqueId: userData.uniqueId, // Extract `uniqueId` from userData
//             action, // Pass the `action` directly from the URL
//             userData, // Include the full user data for email content
//           });
//           console.log("Follow-up email sent successfully.");
//         }

//         setLoading(false);
//       } catch (err) {
//         console.error("Error processing request:", err);
//         setError("An error occurred while processing your request.");
//         setLoading(false);
//       }
//     };

//     checkUserAndProcessRequest();
//   }, [action, userId]);

//   if (loading) {
//     return (
//       <div className="thank-you-page">
//         <div className="thank-you-content">
//           <p>Loading...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="thank-you-page">
//         <div className="thank-you-content">
//           <p>{error}</p>
//           <button onClick={() => window.location.href = '/'}>Return to Home</button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="thank-you-page">
//       <div className="thank-you-content">
//         <h1>{message}</h1>
//         <button onClick={() => window.location.href = '/'}>Return to Home</button>
//       </div>
//     </div>
//   );
// };

// export default CallbackThankYou;

// Firebase Gen2 Usage

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions, functionsB } from "../firebaseConfig"; // Firebase configurations
import "../ThankYouPage.scss";

let debounceTimeout = null; // Declare debounceTimeout outside of the component

const CallbackThankYou = () => {
  const { action, userId } = useParams(); // Extract action and userId from the URL
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const handleRequest = async () => {
      if (!userId || !action) {
        setError("Invalid URL parameters.");
        setLoading(false);
        return;
      }

      // Check for debounce
      if (debounceTimeout) {
        console.log("Skipping duplicate request.");
        return;
      }

      // Set debounce timeout
      debounceTimeout = setTimeout(() => {
        debounceTimeout = null; // Clear timeout after 3 seconds
      }, 3000);

      try {
        console.log("Fetching user data for userId:", userId);

        // Call the Drip project function to get user data
        const getUserDataByUniqueId = httpsCallable(functionsB, "getUserDataByUniqueId");
        const result = await getUserDataByUniqueId({ uniqueId: userId });
        console.log("User data fetched:", result);

        const userData = result.data.userData;
        console.log("User data fetched:", userData);

        console.log("User Id:", userId);
        console.log("Action:", action);
        console.log("User Data:", userData);

        // Step 1: Update Drip project database
        const updateDripStatus = httpsCallable(functionsB, "updateDripStatus");
        const updateResult = await updateDripStatus({ uniqueId: userId, action: action, userData: userData });
        console.log("Update drip status result:", updateResult);
        console.log("HERE: ", updateResult.data.maxCallbackReached);
        console.log("Drip status updated successfully.");

        // Step 2: Send follow-up email (if applicable)
        if (!updateResult.data.maxCallbackReached && action !== "callback-not-interested") {
          const sendFollowUpEmail = httpsCallable(functions, "sendFollowUpEmail");
          await sendFollowUpEmail({ uniqueId: userId, action, userData });
          console.log("Follow-up email sent successfully.");
        } else {
          console.log("Email not sent. Either maxCallbackReached is true or action is callback-not-interested.");
        }

        // Set user-friendly message
        const messages = {
          callback: "Thank you for your request! A representative will be in touch shortly or feel free to call our office on 0191 694 1351.",
          "callback-more-info": "Thank you for your interest! A representative will be in touch shortly or feel free to call our office on 0191 694 1351.",
          "callback-not-interested": "Thank you for letting us know. We appreciate your feedback!",
        };
        setMessage(messages[action] || "Thank you!");
      } catch (err) {
        console.error("Error handling request:", err);
        setError("An error occurred. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    handleRequest();
  }, [action, userId]);

  if (loading) {
    return (
      <div className="thank-you-page">
        <div className="thank-you-content">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2Fheart.png?alt=media&token=9bac356a-789f-4d43-bdc3-be2a6d8e9904"
            alt="Heart Icon"
            className="heart-icon"
          />
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="thank-you-page">
        <div className="thank-you-content">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2Fheart.png?alt=media&token=9bac356a-789f-4d43-bdc3-be2a6d8e9904"
            alt="Heart Icon"
            className="heart-icon"
          />
          <p>{error}</p>
          <button onClick={() => (window.location.href = "/")}>Return to Home</button>
        </div>
      </div>
    );
  }

  return (
    <div className="thank-you-page">
      <div className="thank-you-content">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/content-filter-154e4.appspot.com/o/assets%2Fheart.png?alt=media&token=9bac356a-789f-4d43-bdc3-be2a6d8e9904"
          alt="Heart Icon"
          className="heart-icon"
        />
        <h3>{message}</h3>
        <button onClick={() => (window.location.href = "/")}>Return to Home</button>
      </div>
    </div>
  );
};

export default CallbackThankYou;